export const WS_BASE_URL = process.env.REACT_APP_WS_BASE_URL;
export const SECRET_KEY = "$xd8%MdvYNA^";

export const DBConfig = {
    name: 'answersDB',
    version: 3,
    objectStoresMeta: [
      {
        store: 'answers',
        storeConfig: { keyPath: 'id', autoIncrement: true },
        storeSchema: [
          { name: 'exam', keypath: 'exam', options: { unique: false } },
          { name: 'time', keypath: 'time', options: { unique: false } },
          { name: 'options', keypath: 'options', options: { unique: false } }
        ]
      }
    ]
  };